"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBack = exports.getOffset = exports.getLast = exports.getFirst = exports.calculateLastPageSize = exports.parsePageNumberFromCursor = exports.parseOffsetFromCursor = exports.createCustomOffsetCursor = exports.OFFSET_CURSOR_PREFIX = void 0;
exports.OFFSET_CURSOR_PREFIX = 'OffsetConnection:';
/**
 * Create a custom offset-based cursor in the format "OffsetConnection:N"
 */
const createCustomOffsetCursor = (offset = 0) => btoa(`${exports.OFFSET_CURSOR_PREFIX}${offset}`);
exports.createCustomOffsetCursor = createCustomOffsetCursor;
/**
 * Parse offset from a cursor string.
 * Handles custom offset-based cursors in the format "OffsetConnection:N"
 *
 * @param cursor - Base64-encoded cursor string
 * @returns The offset value, or 0 if parsing fails
 */
const parseOffsetFromCursor = (cursor) => {
    if (!cursor)
        return 0;
    try {
        const decoded = atob(cursor);
        const match = decoded.match(/^OffsetConnection:(\d+)$/);
        return match ? parseInt(match[1], 10) : 0;
    }
    catch (_a) {
        // If cursor is not base64 or doesn't match format, assume offset 0
        return 0;
    }
};
exports.parseOffsetFromCursor = parseOffsetFromCursor;
/**
 * Calculate page number from startCursor.
 *
 * The startCursor always points to the first element on the current page,
 * regardless of pagination direction (forward or backward).
 *
 * Examples (pageSize = 24):
 * - `startCursor: OffsetConnection:0` → page 0
 * - `startCursor: OffsetConnection:24` → page 1
 * - `startCursor: OffsetConnection:96` → page 4
 * - `startCursor: OffsetConnection:120` → page 5
 *
 * @param startCursor
 * @param pageSize - Number of items per page
 * @returns The 0-based page index
 */
const parsePageNumberFromCursor = (startCursor, pageSize = 1) => {
    const offset = (0, exports.parseOffsetFromCursor)(startCursor);
    return Math.floor(offset / pageSize);
};
exports.parsePageNumberFromCursor = parsePageNumberFromCursor;
/**
 * Calculate the size of the last page when total count is not evenly divisible by page size.
 *
 * @param pageSize - Number of items per page
 * @param total - Total number of items
 * @returns The number of items on the last page
 */
const calculateLastPageSize = (pageSize, total = 0) => {
    const fullPages = Math.floor(total / pageSize);
    const remainder = total - fullPages * pageSize;
    return remainder === 0 ? pageSize : remainder;
};
exports.calculateLastPageSize = calculateLastPageSize;
/**
 * Create variables for fetching the first page.
 */
const getFirst = (size) => ({
    first: size,
    after: null,
    before: null,
    last: null,
});
exports.getFirst = getFirst;
/**
 * Create variables for fetching the last page using backward pagination.
 */
const getLast = (size, total) => ({
    before: (0, exports.createCustomOffsetCursor)(total),
    last: size,
    after: null,
    first: null,
});
exports.getLast = getLast;
/**
 * Create variables for fetching a page beginning at the requested offset.
 * GraphQL `after` is exclusive, so its cursor points to the preceding item.
 */
const getOffset = (offset, size) => ({
    after: (0, exports.createCustomOffsetCursor)(Math.max(offset - 1, 0)),
    first: size,
    before: null,
    last: null,
});
exports.getOffset = getOffset;
/**
 * Create variables for backward navigation using a native cursor.
 */
const getBack = (start, size) => ({
    before: start,
    last: size,
    after: null,
    first: null,
});
exports.getBack = getBack;
